// AuthLayout — shell for the pre-app pages without a sidebar: login,
// student profile-setup.
// Navy header bar with brand (and a sign-out button once signed in),
// centered white card on a light background.
import { Outlet } from "react-router-dom";
import SignOutButton from "../auth/SignOutButton.js";

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <header className="flex items-center justify-between gap-3 bg-dm-navy px-6 py-4">
        <p className="font-display text-lg font-semibold tracking-wide text-white">
          Daniels Mediation <span className="text-dm-gold">&amp; ADR</span>
        </p>
        <SignOutButton className="shrink-0" />
      </header>

      <main className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-[400px] rounded-lg bg-white p-8 shadow-lg">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
